// src/i18n/en.js
// English translations - DO NOT MODIFY

const en = {
  // Navigation
  nav: {
    recent: 'Recent',
    explorer: 'Explore',
    favorites: 'Favorites',
    voyages: 'Trips',
    social: 'Social',
    messages: 'Messages',
    profile: 'Profile',
  },

  // Categories
  categories: {
    sejours: 'Short Stay',
    locations: 'Rentals',
    immobilier: 'Real Estate',
    parcelles: 'Land & Properties',
    services: 'Services',
  },

  // Section descriptions (home)
  sections: {
    premiumTitle: 'Featured listings',
    premiumDesc: 'Selected and highlighted',
    sejoursTitle: 'Short Stays',
    sejoursDesc: 'Hotels, furnished studios and rooms',
    locationsTitle: 'Long-term Rentals',
    locationsDesc: 'Apartments and houses per month',
    immobilierTitle: 'Land & Properties',
    immobilierDesc: 'Land and properties for sale',
    servicesTitle: 'Services',
    servicesDesc: 'Cleaning, moving, renovation',
    seeAll: 'See all',
  },

  // Home
  home: {
    title: 'Fynho',
    recentTitle: 'Recently viewed',
    recentDesc: 'Pick up where you left off',
    subtitle: 'Find Your New Home',
    heroTitlePart1: 'Find your',
    heroTitleHighlight: 'new home',
    heroSubtitle: 'Stays, rentals, land and services all across Cameroon.',
    searchPlaceholder: 'City, neighborhood, property type...',
   useLocation: 'Search nearby',
    featured: 'Featured listings',
    viewMap: 'Map',
    noResults: 'No results found',
    listing: 'listing',
    listings: 'listings',
    footerTagline: 'Find Your New Home',
  },

  // Listing
  listing: {
    price: 'Price',
    bedroom: 'Bedroom',
    bedrooms: 'Bedrooms',
    bathroom: 'Bathroom',
    bathrooms: 'Bathrooms',
    area: 'Area',
    capacity: 'Capacity',
    person: 'person',
    persons: 'persons',
    perNight: 'per night',
    perMonth: 'per month',
    perSquareMeter: 'per m²',
    amenities: 'Amenities',
    photos: 'Photos',
    description: 'Description',
    location: 'Location',
    contact: 'Contact',
    phone: 'Phone',
    whatsapp: 'WhatsApp',
    reserve: 'Reserve',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    share: 'Share',
    report: 'Report',
    viewOnMap: 'View on map',
    distance: 'at',
    distanceKm: 'km',
  },

  // Reservation
  reservation: {
    title: 'Request a reservation',
    fullName: 'Full name',
    phone: 'Phone or WhatsApp',
    email: 'Email',
    checkInDate: 'Check-in date',
    checkOutDate: 'Check-out date',
    numberOfGuests: 'Number of guests',
    message: 'Message (optional)',
    submit: 'Send request',
    success: 'Reservation sent successfully!',
    error: 'Error sending reservation',
    terms: 'I accept the terms of use',
  },

  // Admin
  admin: {
    dashboard: 'Dashboard',
    listings: 'Listings',
    reservations: 'Reservations',
    owners: 'Owners',
    users: 'Users',
    admins: 'Administrators',
    quartiers: 'Neighborhoods',
    types: 'Listing types',
    reviews: 'Reviews',
    reports: 'Reports',
    stats: 'Statistics',
    auditLogs: 'Audit logs',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    approve: 'Approve',
    reject: 'Reject',
    view: 'View',
    actions: 'Actions',
    status: 'Status',
  },

  // Status
  status: {
    draft: 'Draft',
    pending: 'Pending',
    published: 'Published',
    rejected: 'Rejected',
    disabled: 'Disabled',
    new: 'New request',
    contacted: 'Contacted',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    archived: 'Archived',
  },

  // Common messages
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    ok: 'OK',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    noData: 'No data',
    tryAgain: 'Try again',
    language: 'Language',
    theme: 'Theme',
    themeDark: 'Dark',
    themeLight: 'Light',
    settings: 'Settings',
    help: 'Help',
    support: 'Support',
    logout: 'Logout',
    all: 'All',
  },

  // Errors
  errors: {
    required: 'This field is required',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone number',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
    passwordMismatch: 'Passwords do not match',
    networkError: 'Network error. Check your connection.',
    serverError: 'Server error. Try again later.',
    notFound: 'Resource not found.',
    unauthorized: 'Authentication failed.',
    forbidden: 'Access denied.',
    validationError: 'Please check the entered data.',
  },

  // Neighborhoods (examples)
  quartiers: {
    bonapriso: 'Bonapriso',
    bastos: 'Bastos',
    akwa: 'Akwa',
    bonanjo: 'Bonanjo',
    douala: 'Douala',
    yaounde: 'Yaounde',
    bafoussam: 'Bafoussam',
    kumba: 'Kumba',
  },
  settings: {
    account: 'Account',
    general: 'General',
    permissions: 'Device permissions',
    themeColor: 'Theme color',
    about: 'About',
    darkTheme: 'Dark theme',
    geolocation: 'Location',
    notifications: 'Notifications',
    shareApp: 'Share Fynho',
    helpSupport: 'Help & Support',
    loginPrompt: 'Log in to save your favorites and reviews.',
    login: 'Log in',
    logout: 'Log out',
    confirmLogout: 'Log out?',
    geoActive: 'Enabled',
    geoBlocked: 'Blocked',
    geoInactive: 'Disabled',
    notifActive: 'Enabled',
    notifBlocked: 'Blocked',
    notifInactive: 'Not enabled',
    notifUnsupported: 'Not available',
    notifNeedsInstall: 'Requires installation',
    iosNotifHint: 'On iPhone, notifications only work if Fynho is installed on your home screen. Open Safari\'s share menu (⬆️ icon) then "Add to Home Screen".',
    generalHint: 'Location shows you listings near you. Notifications will soon alert you about your favorites and reviews.',
    privacyPolicy: 'Privacy Policy',
    deleteAccount: 'Delete my account',
  },
  support: {
    heroTitle1: 'Find Your',
    heroTitle2: 'New Home',
    heroSubtitle: 'The Cameroonian real estate platform to find stays, rentals, land and services, with confidence.',
    adv1Title: 'Verified listings',
    adv1Text: 'Every property published on Fynho is reviewed by our team before going live.',
    adv2Title: 'Location-based search',
    adv2Text: 'Instantly find homes, land and services closest to you.',
    adv3Title: 'Direct, fast contact',
    adv3Text: 'Message us in one tap on any listing, we reply as quickly as possible.',
    adv4Title: 'Built for Cameroon',
    adv4Text: 'Stays, rentals, land and services in Douala, Yaoundé and all major cities.',
    needHelp: 'Need help?',
    faqTitle: 'Frequently asked questions',
    faq1q: 'How do I contact a listing?',
    faq1a: 'Open a listing and tap "Contact". You can message on WhatsApp or call directly.',
    faq2q: 'Is payment done in the app?',
    faq2a: 'No. No payment goes through Fynho. Payment is always made directly with the contact shown on the listing.',
    faq3q: 'Do I need to create an account?',
    faq3a: 'No, browsing and contacting are possible without an account. Creating one lets you save favorites and leave reviews.',
    faq4q: 'How do I list a property?',
    faq4a: 'Message us on WhatsApp or email: we\'ll help you get your property online quickly.',
  },

  // Privacy Policy
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last updated: July 5, 2026',
    intro: 'Fynho respects your privacy. This policy explains what data we collect, how we use it, and your rights.',
    section1Title: '1. Data we collect',
    section1Location: 'Location (GPS): we request access to your position only to show you nearby listings on the map. This data is never permanently stored or shared.',
    section1Account: 'User account: if you create an account, we collect your name, phone number and/or email, and your password (encrypted).',
    section1Content: 'Published content: if you post a listing, we store the title, description, price, photos, property location and your contact details.',
    section1Usage: 'Usage data: we may collect basic information about app usage to improve the service.',
    section2Title: '2. How we use your data',
    section2Text: 'To display relevant listings based on your location, let you publish and manage your listings, let you contact owners via WhatsApp, and improve the app\'s quality. We never sell your data.',
    section3Title: '3. Data sharing',
    section3Text: 'Your data is only shared with a listing owner if you choose to contact them. No other third party, except legal obligation.',
    section4Title: '4. Security',
    section4Text: 'Your data is stored on secure servers. Passwords are encrypted. Communications are protected via HTTPS.',
    section5Title: '5. Your rights',
    section5Text: 'You can view, edit your information, or delete your account and all associated data at any time.',
    section6Title: '6. Account deletion',
    section6Text: 'To delete your account, use the "Delete my account" button in settings, or contact us at support@fynho.com. Your request will be processed within 30 days maximum.',
    section7Title: '7. Children',
    section7Text: 'Fynho is not intended for children under 13. We do not knowingly collect data from minors.',
    section8Title: '8. Changes',
    section8Text: 'We may update this policy from time to time. Any significant change will be notified within the app.',
    contactTitle: 'Contact',
    contactText: 'For any question about this policy or your personal data:',
  },

  // Account deletion
  deleteAccount: {
    title: 'Delete my account',
    warning: 'This action is irreversible.',
    warningText: 'All your data will be permanently deleted: profile, favorites, reviews, and published listings.',
    confirmLabel: 'Type "DELETE" to confirm',
    confirmPlaceholder: 'DELETE',
    confirmButton: 'Permanently delete my account',
    cancelButton: 'Cancel',
    success: 'Your account has been successfully deleted.',
    error: 'Error while deleting. Try again or contact support.',
    passwordRequired: 'Please enter your password to confirm',
  },

  getApp: {
    button: 'Get the app',
    ios: {
      step0Title: 'Open the Safari menu',
      step0Text: 'Tap the "•••" button at the bottom of the screen.',
      step1Title: 'Tap Share',
      step1Text: 'The "Share" option appears in the menu, tap it.',
      step2Title: 'The share menu opens',
      step2Text: 'Scroll down to see more options.',
      step3Title: 'Find "Add to Home Screen"',
      step3Text: 'Keep scrolling until you see this option, then tap it.',
      step4Title: 'Tap Add',
      step4Text: 'Confirm at the top right to finish the installation.',
      finalTitle: 'Fynho is now on your home screen',
      finalText: 'Open Fynho from its icon like an app.',
    },
    android: {
      title: 'Install Fynho on Android',
      subtitle: 'Download the app and install it in a few simple steps.',
      downloadButton: 'Download Fynho',
      stepsTitle: 'After downloading',
      step1: 'Open the downloaded Fynho file',
      step2: 'Allow installation if Android asks',
      step3: 'Tap Install',
      step4: 'Open Fynho',
    },
  },
};

export default en;